import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";
import AnchorLink from "react-anchor-link-smooth-scroll";
import dices from "../svg/dices.svg";
import h1 from "../svg/3x.png";
import Schedule from "./components/MainComponents/Schedule";
import TicketAvailability from "./components/MainComponents/TicketAvailability";
import SubmitProgramItem from "./components/MainComponents/SubmitProgramItem";
import LoadingDots from "./components/LoadingDots";

const HomePageTeachers = () => {
  const [t, i18n] = useTranslation("global");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true); 
    console.log(form.current);
    emailjs
      .sendForm(
        "service_v8sqigr",
        "template_i8n2y0c",
        form.current,
        "kvvx_padstf0o02_b"
      )
      .then(
        (result) => {
          console.log(result.text);
          setLoading(false);
          setSubmitted(true);
        },
        (error) => {
          console.log(error.text);
          setLoading(false);
        }
      );
    e.target.reset();
  };

  let background = {
    backgroundImage: `url(${h1})`,
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPositionY: "top",
  };

  return (
    <div className="App  mx-auto">
      <div className="bg-local lg:h-screen justify-items-center pt-40 flex justify-center">
        <div className="w-full " style={background}>
          <div
            style={{
              fontFamily: "Bebas Neue",
              textShadow: "rgba(0,0,0,0.5) 1px 0 10px",
            }}
            className="2xl:pt-60 sm:pt-40  text-white font-bold text-center text-5xl"
          >
            27.02.2026 - 01.03.2026
          </div>

          <div
            className="text-white  text-center w-screen text-s uppercase"
            style={{
              fontFamily: "Bebas Neue",
              textShadow: "rgba(0,0,0,0.5) 1px 0 10px",
            }}
          >
            {t("home.main-location")}
          </div>
          <div
            style={{
              fontFamily: "Bebas Neue",
              textShadow: "rgba(0,0,0,0.5) 1px 0 10px",
            }}
            className="pt-8 px-10 text-white w-full text-center 2xl:text-9xl xl:text-9xl lg:text-6xl md:text-3xl sm:text-3xl"
          >
            {t("home.game-studios")}
          </div>
          <div className="pt-8 w-full grid grid-cols-1 gap-4 place-content-center mt-2">
            <div
                style={{ fontFamily: "Poppins" }}
                className="border-white text-white text-center text-lg place-self-center lg:-mt-0 -mt-4 px-4 sm:px-8"
            >
              <AnchorLink
                  className="
                            border-solid border-2 border-white
                            bg-teal-600/50 hover:bg-green-white hover:text-white
                            text-white text-center text-lg
                            py-3 px-6 sm:py-4 sm:px-10 md:py-6 md:px-20
                          "
                  href="#moreInfo"
                  id="about"
              >
                {t("home.see-more")}
              </AnchorLink>
            </div>
          </div>
        </div>
      </div>
      <div id="moreInfo" style={{height:"100px"}}/>
      <div className="grid pt-20 grid-cols-1 gap-4 justify-items-center"> 
        <section id="general" className="w-full">
          <div className="w-1/2 mx-auto">
            <div
              className="
                grid 
                grid-cols-1
                lg:grid-cols-[20%_80%] 
                gap-6 
                items-start
              "
            >
              <div className="flex justify-center lg:justify-start">
                <img
                  src={dices}
                  className="w-80"
                  alt="logo"
                />
              </div>

              <div className="w-full">
                <div className="border-dotted border-l-4 pl-4">
                  <div
                    style={{ fontFamily: "Bebas Neue" }}
                    className="text-green-white text-center lg:text-left text-5xl"
                  >
                    {t("home.generl-info")}
                  </div>

                  <div
                    style={{ fontFamily: "Poppins", width:"100" }}
                    className="text-black text-center lg:text-justify text-base pt-8 px-2"
                  >
                    {t("home.general-info-text-academic")}
                    <br /><br />
                    <p className="text-left">
                      {t("home.location")} {t("home.main-location")}
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>
        <section id="program" className="grid grid-cols-1 gap-4 justify-items-center pt-12" style={{ width:'95%', overflow:'visible'}}>
          <SubmitProgramItem page="academic"/>
        </section>
        <section id="tickets"className="grid grid-cols-1 gap-4 justify-items-center pt-12">
          <TicketAvailability page="academic"/>
        </section>
        <section id="schedule" className="grid grid-cols-1 gap-4 justify-items-center pt-12"  style={{maxWidth:'100%', width:'100%'}}>
          <Schedule page="academic" language={i18n.language} />
        </section>
        <section className="grid grid-cols-1 gap-4 justify-items-center pt-12">
          <div
            style={{ fontFamily: "Bebas Neue" }}
            className="text-center text-5xl"
          >
            {t("home.what-to-expect-title")}
          </div>
          <div
            style={{ fontFamily: "Poppins", textAlignLast: "center" }}
            className="text-justify text-base lg:w-1/2 w-11/12 place-items-center text-align-last:center"
          >
            {t("home.what-to-expect-description")}
            <br />
            <br />
            <b>{t("home.what-to-expect-bold")}</b>
          </div>
          <div className="border-b-2 w-48 border-red-800 pt-10"></div>
        </section>
        <section className="grid lg:grid-cols-1 sm:grid-cols-1 gap-4 justify-items-center pt-12" id="contacts">
          <div className="grid grid-cols-1 justify-items-center">
            <div
              style={{ fontFamily: "Bebas Neue" }}
              className="text-green-white text-left text-5xl justify-self-center"
            >
              {t("home.contacts-form")}
            </div>
            <div
              style={{ fontFamily: "Poppins", textAlignLast: "center" }}
              className="text-black lg:w-1/2 px-2 text-justify text-base pt-2 justify-self-center"
            >
              {t("home.contact-form-text-academic")}
            </div>
            <div className="grid lg:grid-cols-2 w-full sm:grid-cols-1 gap-4 auto-cols-auto justify-items-center">
                {loading ? (
                  <div className="lg:w-3/5 sm:w-11/12 w-11/12 pt-0 lg:justify-self-end flex justify-center items-center">
                    <LoadingDots page="school" />
                  </div>
                ) : !submitted ? (
                <form
                ref={form}
                onSubmit={sendEmail}
                className="lg:w-3/5 sm:w-11/12 w-11/12 pt-12 sm:justify-self-center md:justify-self-center lg:justify-self-end"
              >
                <div className="relative w-full mb-3 group border-2 border-green-white w-90%">
                  <input
                    autoComplete="off"
                    type="text"
                    name="name"
                    id="name"
                    className="block pl-10 py-4 px-0 w-full text-base text-black bg-transparent appearance-none dark:text-green-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    required
                  />
                  <label className="peer-focus:font-medium absolute text-base text-green-white italic pl-10 dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-black peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5">
                    {t("home.name")}
                  </label>
                </div>
                <div className="relative w-full mb-3 group border-2 border-green-white">
                  <input
                    autoComplete="off"
                    type="email"
                    name="email"
                    id="email"
                    className="block pl-10 py-4 px-0 w-full text-base text-black bg-transparent appearance-none dark:text-green-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    required
                  />
                  <label className="peer-focus:font-medium absolute text-base text-green-white italic pl-10  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-black peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5">
                    {t("home.e-mail")}
                  </label>
                </div>

                <div className="relative w-full h-80 group border-2 border-green-white">
                  <textarea
                    maxLength="2000"
                    autoComplete="off"
                    type="text"
                    name="message"
                    id="message"
                    className="block resize-none pl-10 py-8 px-0 w-full text-base text-black bg-transparent appearance-none dark:text-green-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    required
                  />
                  <label className="peer-focus:font-medium absolute text-base text-green-white italic pl-10  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-black peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3">
                    {t("home.your-message")}
                  </label>
                </div>
                <div className="relative w-full mb-3 group bg-lime-600">
                  <button
                    type="submit"
                    value="Send"
                    className="text-white bg-gradient-to-r from-green-white to-green-dark hover:bg-lime-500 focus:ring-4 focus:outline-none focus:bg-lime-900 font-medium text-xl w-full px-5 py-4 text-center"
                  >
                    {t("home.send-contact")}
                  </button>
                </div>
                </form> ) : (
                    <div className="w-full pt-0 lg:justify-self-end text-[#12d7a6] text-3xl text-center pt-12" style={{ width:'60%', fontFamily:"Bebas Neue" }}>
                      {t("home.thank-you-contact")}
                    </div>
                  )}
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2484.9916265955617!2d11.971946299999999!3d51.476668!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a663daa70a6bf5%3A0x8d695ba67d78f1d7!2sHaus%2031%20-%20Institut%20f%C3%BCr%20Schulp%C3%A4dagogik%20und%20Grundschuldidaktik!5e0!3m2!1spt-PT!2spt!4v1772188550366!5m2!1spt-PT!2spt" 
                // width="410"
                height="494"
                loading="lazy"
                title="google maps"
                className="pt-12 lg:w-3/5 w-full justify-self-start lg:w-3/5"
              ></iframe>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomePageTeachers;
